/**
 * Contact form popup
 *
 * Shows a confirmation popup after a successful contact form submission.
 * Uses sessionStorage to persist the "submitted" flag across the form's
 * page redirect so the popup can be displayed on the next render.
 *
 * Each popup is bound to its form via the `data-contact-form-popup`
 * attribute, whose value is the form's `id`. This supports multiple
 * contact form instances on the same page.
 */

const STORAGE_KEY_SUFFIX = '__successful_submitted';

/**
 * @param {HTMLElement} popup
 */
function initContactFormPopup(popup) {
  const formId = popup.dataset.contactFormPopup;
  if (!formId) return;

  const form = document.getElementById(formId);
  if (!form) return;

  const storageKey = `${formId}${STORAGE_KEY_SUFFIX}`;
  const successMessage = document.querySelector(`[data-contact-form-success="${formId}"]`);

  if (sessionStorage.getItem(storageKey) === null) {
    sessionStorage.setItem(storageKey, 'false');
  }

  form.addEventListener('submit', () => {
    sessionStorage.setItem(storageKey, 'true');
  });

  const openPopup = () => {
    popup.hidden = false;
    document.body.style.overflow = 'hidden';
    if (successMessage) successMessage.classList.add('visually-hidden');
    sessionStorage.setItem(storageKey, 'false');
  };

  const closePopup = () => {
    popup.hidden = true;
    document.body.style.overflow = '';
    sessionStorage.setItem(storageKey, 'false');
  };

  popup.querySelectorAll('[data-contact-form-popup-close]').forEach((el) => {
    el.addEventListener('click', closePopup);
  });

  if (sessionStorage.getItem(storageKey) === 'true') {
    openPopup();
  }
}

document.querySelectorAll('[data-contact-form-popup]').forEach((popup) => {
  initContactFormPopup(/** @type {HTMLElement} */ (popup));
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const visiblePopup = document.querySelector('[data-contact-form-popup]:not([hidden])');
  if (!visiblePopup) return;
  visiblePopup.hidden = true;
  document.body.style.overflow = '';
  const formId = visiblePopup.dataset.contactFormPopup;
  if (formId) sessionStorage.setItem(`${formId}${STORAGE_KEY_SUFFIX}`, 'false');
});
